import { h, Fragment } from "preact";


export function AgenticSearchResultsHTML(props: any) {
    const { searchResponse } = props?.msgData;
    return (
        <Fragment>

        {
                <div className={"suggestion-item-card aa-each-suggestion"}>
                    <div className="suggestion-header-faq aa-suggestion-header">
                        <div className="titles-info-sec aa-suggestion-title">
 
                            {props?.msgData?.searchResponse?.length > 0 && props?.msgData?.searchResponse?.query && (
                                <h2 className="aa-text-xs">{searchResponse?.query}</h2>
                            )}
                        </div>
                    </div>
                    <div className="suggestion-body-faq">
                        <p className="aa-desc-xs suggestion-paragraph aa-agentic-search-results-title" dangerouslySetInnerHTML={{ __html: props?.msgData?.hostInstance?.rootService?.sanitizeHTML(searchResponse?.response[0]?.content) }} />

                        <div className="more-links-buttons aa-seemore-buttons aa-hidden">
                            <button className="more-link-text aa-text-xs aa-more-button"  role="link">{props?.msgData?.hostInstance?.languagedata?.MORE_TEXT}</button>
                        </div>
                    </div>

                </div>

        }
        </Fragment>
     )
}